import React from 'react';
import cx from 'classnames';

import wrapStore from '@src/utils/wrap-store';

import NewMechaScreenStore from '@src/pages/main/components/new-mech-screen/store';

const styles = require('./index.less');

const NewMechaScreen = ({ store }) => {
  return (
    <div className={cx(styles.newMechScreenRoot, store.isActive && styles.newMechScreenRootAct)}>
      <div className={styles.mechGroup}>
        <div className={cx(styles.mech, styles.mech1)}>
          <div className={styles.mechImg} />
          <div className={styles.cardDecorate} />
          <div className={styles.mechName} />
          <div className={styles.mechProducer} />
        </div>
        <div className={cx(styles.mech, styles.mech2)}>
          <div className={styles.mechImg} />
          <div className={styles.cardDecorate} />
          <div className={styles.mechName} />
          <div className={styles.mechProducer} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(NewMechaScreen, NewMechaScreenStore);
